export default __webpack_public_path__ + "static/media/advantages__item-icon-3.fe1bccee.svg";